export default __webpack_public_path__ + "static/thank-You-dfb6bcdc4c8b5dcadc46a0264e88abd9.png";